import script from "./ChassisSectionStandard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChassisSectionStandard.vue?vue&type=script&setup=true&lang=js"

import "./ChassisSectionStandard.vue?vue&type=style&index=0&id=2593712a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2593712a"]])

export default __exports__